import { useEffect } from "react";
import TagManager from "react-gtm-module/dist/TagManager";

export const GTM_EVENT = Object.freeze({
  PAGE_VIEW: "pageView",
  ADD_TO_CART: "addToCart",
  DROP_LEAD: "dropLead",
  PURCHASED: "purchasedOnline",
  CALCULATE: "calculateForm",
});

export default function useGtm(page = "", isPageView = true) {
  const gtmId = process.env.GTM_ID;
  const init = {
    gtmId: gtmId,
    events: {
      page: page,
    },
  };
  const buildInit = (newEvents) => {
    const dataObj = {
      ...init,
      events: {
        ...init.events,
        ...newEvents,
      },
    };
    return dataObj;
  };
  useEffect(() => {
    if (!isPageView) {
      return;
    }
    const data = {
      event: GTM_EVENT.PAGE_VIEW,
    };
    const gtmArgs = buildInit(data);    
    TagManager.initialize(gtmArgs);
  }, []);

  const onSendGtmEvent = (eventName, eventData = {}, component = "") => {
    const data = {
      event: eventName,
      ...eventData,
      component: component,
    };
    const gtmArgs = buildInit(data);
    TagManager.initialize(gtmArgs);
};

  return { onSendGtmEvent };
}
